import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import Loading from './loading'
import 'bootstrap/dist/css/bootstrap.min.css'
import './app.css'
import ProgressBar from './ProgressBar/ProgressBar';
import { fetchTeamBySlug, fetchPage, fetchPageTags, fetchMemberFitnessActivities, deserializeFitnessActivity } from './utils'
import { sum, sumBy } from 'lodash'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(relativeTime)
dayjs.extend(utc)

const App = () => {
  const [loading, setLoading] = useState(false)

  // total amount raised or total fitness
  const [amount, setAmount] = useState(0)
  // either fitness or fundraising target
  const [target, setTarget] = useState(0)

  const search = window.location.search
  const params = new URLSearchParams(search)

  // options are individualFundraising, individualFitness, teamFundraising
  const type = params.get('barType')
  const slug = params.get('slug')
  const startDate = params.get('startDate') || '2025-06-30T23:00:00.000Z'
  const endDate = params.get('endDate') || '2025-09-30T23:00:00.000Z'

  const handleFetchIndividualFitness = () => Promise.resolve()
  .then(()=> setLoading(true))
  .then(()=> Promise.all([fetchMemberFitnessActivities({ page: `fundraising/${slug}`, allActivities: true }), fetchPage(slug, true, {includeTags: true})]))
  .then(([fitness, page])=>{
      const stepGoal = page.tags.find(({tagDefinition: {id}}) => id === "DSFitnessGoalTargetMeters")?.value
      const fitnessActivities = fitness
        .map(item => ({ ...deserializeFitnessActivity(item), activityType: 'fitness' }))
        .filter(activity => {
          if (startDate && endDate) {
            const activityDate = dayjs.utc(activity.createdAt)
            return activityDate.isSameOrAfter(startDate) && activityDate.isSameOrBefore(endDate)
          }

          return true
        })
      setAmount(sumBy(fitnessActivities, 'steps'))
      setTarget(stepGoal)
  })
  .then(() => setLoading(false))
  .catch(error => {
    setLoading(false)
    return Promise.reject(error)
  })


  const handleFetchIndividual = () => Promise.resolve()
  .then(() => setLoading(true))
  .then(() => fetchPage(slug, true))
  .then((page)=> {
      setAmount(parseInt(page.totalRaisedOnline) + parseInt(page.totalRaisedOffline))
      setTarget(page.fundraisingTarget)
  })
  .then(() => setLoading(false))
  .catch(error => {
    setLoading(false)
    return Promise.reject(error)
  })

  const handleFetchTeam = () => Promise.resolve()
  .then(() => setLoading(true))
  .then(() => fetchTeamBySlug(slug))
  .then((team)=> {
    setAmount(team.donationSummary.totalAmount)
    setTarget(team.fundraisingConfiguration.targetAmount)
  })
  .then(() => setLoading(false))
  .catch(error => {
    setLoading(false)
    return Promise.reject(error)
  })

  const handleFetchTeamFitness = () => Promise.resolve()
  .then(() => setLoading(true))
  .then(() => fetchTeamBySlug(slug, { includePages: true }))
  .then(async (team)=> {
    const membersFitness = []
    const members = []
    for (let x = 0; x < team.membership.members.length; x++) {
      const member = team.membership.members[x]
      const memberFitnessActivities = await fetchMemberFitnessActivities({ page: member.fundraisingPageShortName, allActivities: true })
      const memberFitnessTotal = sumBy(memberFitnessActivities, 'steps')
      const teamMamberTags = await fetchPageTags(member.fundraisingPageShortName.replace('fundraising/', ''))
      const fitnessTargetTag = teamMamberTags.tags.find(({tagDefinition: {id}}) => id === "DSFitnessGoalTargetMeters")
      const parsedFitnessTarget = parseInt(fitnessTargetTag?.value) || 0
      members.push(parsedFitnessTarget)
      membersFitness.push(memberFitnessTotal)
    }
    setAmount(sum(membersFitness))
    setTarget(sum(members))
  })
  .then(() => setLoading(false))
  .catch(error => {
    setLoading(false)
    return Promise.reject(error)
  })

  useEffect(() => {
    if (type === 'individualFundraising') {
      handleFetchIndividual()
    }
    if (type === 'individualFitness') {
      handleFetchIndividualFitness()
    }
    if (type === 'teamFundraising') {
      handleFetchTeam()
    }
    if (type === 'teamFitness') {
      handleFetchTeamFitness()
    }
  }, [])

  if (loading) {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='loading'>
              <Loading size={2} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <ProgressBar
      type={type}
      amount={amount}
      target={target}
    />
  )
}

ReactDOM.render(<App />, document.getElementById('app'))









